define('evicommon/state/param.adapter',['require','exports','module','underscore','backbone','jquery'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var jQuery = require('jquery');

  var parameterizeFieldValues = function(searchServiceFields) {
    return !!searchServiceFields ? '&field=' + searchServiceFields.join('&field=') : '';
  };

  function ParamAdapter(model, options) {
    this.model = model instanceof Backbone.Model ? model : new Backbone.Model(model);
    this.options = _.extend({}, _.result(this, 'options'), options);
    this.initialize(this.model, this.options);
  }

  ParamAdapter.extend = Backbone.View.extend;

  _.extend(ParamAdapter.prototype, {
    initialize: function(model, options) {},

    serializeModel: function() {
      //prettier-ignore
      var serializedJSON,
         searchServiceFields = this.model.get('fields');

      // If we are parametizing search service API params, since all the fields have the same param name,
      // the jQuery param() method will only set the last one passed. So we temporarily remove search service fields before we
      // serialize the model.  Then we add them back in for future requests.
      this.model.unset('fields');
      serializedJSON = this.model.toJSON();
      if (searchServiceFields) {
        this.model.set({ fields: searchServiceFields });
      }

      return serializedJSON;
    },

    setup: function(collection) {
      if (this.options.autoFetch === true) {
        var fetch = _.debounce(function() {
          collection.fetch();
        });
        collection.once(
          'request',
          function() {
            this.model.on('change', function(model, options) {
              if (!_.result(options, 'ignoreAutoFetch')) {
                fetch();
              }
            });
          },
          this
        );
      }
    },

    preprocess: function(options) {
      //prettier-ignore
      var searchServiceFields = this.model.get('fields'),
          data                = this.serializeModel(),
          beforeSend          = options.beforeSend;

      options.beforeSend = function(jqXHR, options) {
        var url = options.url;
        if (String(url).indexOf('?') !== -1) {
          url += '&';
        } else {
          url += '?';
        }
        options.url = url + jQuery.param(data) + parameterizeFieldValues(searchServiceFields);
        if (_.isFunction(beforeSend)) {
          beforeSend.apply(this, arguments);
        }
      };
    },
  });

  module.exports = ParamAdapter;
});

